import Button from "../../../Components/Button";
import { IAdditional } from "../../TableTemplate/tableTemplate";
import { TableCell } from "@mui/material";
import { useState } from "react";
import { Edit } from "@mui/icons-material";
import { Modal } from "src/Components";
import { IBorderTableReport } from "src/Interfaces/deltaHedgeBackTest";
import Config from "./Config";

const TableAdditionalHeader: React.FC = ({}) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">ویرایش</span>
      </TableCell>
    </>
  );
};

const AdditionalCol: React.FC<{
  row: IBorderTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <TableCell>
        {isOpen ? (
          <Modal
            title="تنظیمات دهک"
            onClose={() => setIsOpen(false)}
            UI={
              <Config
                decileNumber={row.decileNo}
                groupId={row.groupId}
                profileId={row.profileId}
                onClose={() => {
                  setIsOpen(false);
                  if (onAction) onAction();
                }}
              />
            }
          />
        ) : (
          <></>
        )}
        {row.row !== 1 ? (
          <div className="w-min mx-auto">
            <Button
              text={<Edit />}
              variant="contained"
              onClick={() => setIsOpen(true)}
              className="table-btn"
            />
          </div>
        ) : (
          <></>
        )}
      </TableCell>
    </>
  );
};

export const TableAdditional: IAdditional<IBorderTableReport> = {
  getHeader: TableAdditionalHeader,
  getRow: AdditionalCol,
};
